module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8wp3vv/tc-custom/9781399082259.jpg?1729185199639",
      "alt": "This image is the cover for the book Malayan Emergency, Images of War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Malayan Emergency, Images of War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From 1948 through the 1950s British and Commonwealth forces fought a ruthless communist insurgency on the Malay peninsula. Thanks to sound generalship and the dedication and resilience of the officers and men, the security forces eventually broke the terrorists’ resolve.  1st Battalion The Suffolk Regiment was just one of many British units involved in this successful campaign, known as the Malayan Emergency. Their tour between 1949 and 1953 coincided with the most crucial years when the future of the country and, arguably, the South East Asia region lay in the balance.  As this book describes in words and superb contemporary images how the Battalion, the majority of whom were National Servicemen, operated under the most demanding jungle and climatic conditions, earning itself an enviable reputation. The Battalion’s experiences are well recorded here and typify those of tens of thousand servicemen whose efforts secured a unique victory.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Forsdike\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mark Forsdike has strong links with the Suffolk Regiment. His grandfather served with the 4th Battalion in the Second World War spending three and a half years as a Japanese prisoner of war. Mark is proud to be an honorary member of the Old Comrades Association, Standard Bearer of the Ipswich Branch, a volunteer at the Regimental Museum and administrator of the Friends of the Suffolk Regiment.  An engineer by profession, he lives in Ipswich with his wife and two children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0